'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _components = require('../../components');

var _Issues = require('./Issues.css');

var _Issues2 = _interopRequireDefault(_Issues);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Issues = (_dec = (0, _reactCssModules2.default)(_Issues2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Issues, _Component);

  function Issues(props) {
    (0, _classCallCheck3.default)(this, Issues);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Issues.__proto__ || (0, _getPrototypeOf2.default)(Issues)).call(this, props));

    _this.state = {
      title: 'The issues',
      description: 'We rate retirement plans and mutual funds on environmental and social sustainability issues.',
      url: _config2.default.domain + _config2.default.routes.issues
    };
    return _this;
  }

  (0, _createClass3.default)(Issues, [{
    key: 'render',
    value: function render() {
      var descriptions = {
        'Fossil fuels': 'Coal, oil, and gas release carbon pollution that accelerates the climate emergency.',
        'Fossil fuel finance & insurance': 'Banks and insurers are financing and underwriting fossil fuels - including tar sands, arctic drilling, and coal mining.',
        'Deforestation': 'Clearing rain forests for cattle grazing or palm oil production contributes to the climate crisis and threatens the rights of Indigenous peoples.',
        'Gender equality': 'Collecting data and scoring companies on gender equality is the first step towards sustainable change.',
        'Civilian firearms': 'Retirement plans are investing in firearm manufacturers and retailers raking in billions in handgun, assault rifle, and ammunition sales.',
        'Prison industrial complex': 'Investor-owned companies are profiting from exploitative prison labor, immigration jails, and other economic systems of oppression and exploitation.',
        'Arms manufacturers': 'Through the global weapons trade, some arms manufacturers supply military goods to states at risk of using weapons for oppression or aggression.',
        'Tobacco': 'Smoking is a leading cause of preventable death. Most smokers start before they’re 18. Every day, more than 2,000 young Americans become daily smokers.'
      };
      //
      return _react2.default.createElement(
        'div',
        { styleName: 'page' },
        _container2.default.helmet(this.state.title, this.state.description, this.state.url),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'h1',
            { styleName: 'large-page-title' },
            this.state.title
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'content' },
            _react2.default.createElement(
              'h2',
              null,
              'We rate retirement plans and mutual funds on environmental and social sustainability issues.'
            ),
            _react2.default.createElement(
              'nav',
              { styleName: 'nav-flex' },
              [[_config2.default.routes.issueFossilFuels, 'Fossil fuels', 'fossil-fuels'], [_config2.default.routes.issueFossilFuelFinanceInsurance, 'Fossil fuel finance & insurance', 'fossil-fuel-finance-insurance'], [_config2.default.routes.issueDeforestation, 'Deforestation', 'deforestation'], [_config2.default.routes.issueGenderEquality, 'Gender equality', 'gender-equality'], [_config2.default.routes.issueCivilianFirearms, 'Civilian firearms', 'civilian-firearms'], [_config2.default.routes.issuePrisonIndustrialComplex, 'Prison industrial complex', 'prison-industrial-complex'], [_config2.default.routes.issueArmsManufacturers, 'Arms manufacturers', 'arms-manufacturers'], [_config2.default.routes.issueTobacco, 'Tobacco', 'tobacco']].map(function (e, i) {
                var _e = (0, _slicedToArray3.default)(e, 3),
                    url = _e[0],
                    title = _e[1],
                    imgName = _e[2];

                var description = descriptions[title] || 'Lorem';
                return _react2.default.createElement(
                  'div',
                  { styleName: 'issue-link' },
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: url,
                      title: 'Issue: ' + title
                    },
                    _react2.default.createElement('div', { styleName: 'img-' + imgName }),
                    _react2.default.createElement(
                      'h3',
                      null,
                      title
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      description
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      'Learn more',
                      _react2.default.createElement(_components.LinkIcon, null)
                    )
                  )
                );
              })
            )
          )
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null)
      );
    }
  }]);
  return Issues;
}(_react.Component)) || _class);
exports.default = Issues;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Issues/Issues.js
// module id = 1488
// module chunks = 0